// src/services/vitalsApi.js
// Vitals (BE-2) and the visit intake call (BE-1) — docs/visit-workflow-contract.md.
// Both are clinic-staff endpoints; a 403 here is "not allowed", not an expired
// session, so the axios interceptor's logout-on-403 is switched off.
import api from './api';

const STAFF = { treat403AsForbidden: true };

export const vitalsAPI = {
  // POST /api/clinic/patients/{patientId}/vitals -> VitalsReading (201)
  record: (patientId, body) => api.post(`/clinic/patients/${patientId}/vitals`, body, STAFF),

  // GET /api/clinic/patients/{patientId}/vitals?limit= -> VitalsReading[] newest first
  list: (patientId, limit = 20) =>
    api.get(`/clinic/patients/${patientId}/vitals`, { params: { limit }, timeout: 15000, ...STAFF }),
};

// PUT /api/clinic/visits/by-appointment/{appointmentId}/intake
//   {chiefComplaint?, currentMedicines?} -> Visit. The endpoint belongs to the
// visit workstream (BE-1); it lives here so the intake form has one module.
// 409 when the visit is already SIGNED.
export const saveIntake = (appointmentId, body) =>
  api.put(`/clinic/visits/by-appointment/${appointmentId}/intake`, body, STAFF);

export default vitalsAPI;
